import { sleep } from './utils.js';

/**
 * Custom fetch mit Retry
 * @param {string} uri - URI zur Resource
 * @param {object} options - fetch options
 * @param {number} n - Anzahl der Versuche/Retries
 * @param {number} t - Verzögerung zwischen den Versuchen in ms
 * @returns {object}
 */
function fetchRetry(url, options, n, t = 1000) {
    return fetch(url, options)
        .then((response) => {
            if (response.ok) return response;
            throw new Error("Network response was not ok");
        })
        .catch(async (error) => {
            if (n === 1) throw new Error(error);
            await sleep(t);
            return fetchRetry(url, options, n - 1);
        })
};

async function abortableFetch(url, options = {}) {
    const { timeout = 6000 } = options;
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), timeout);
    const response = await fetch(url, {
        ...options,
        signal: controller.signal
    });
    clearTimeout(timeoutId);
    return response;
}

export {
    fetchRetry,
    abortableFetch
}
